var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBicicle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.11,
    height: 17.63,
    viewBox: "0 0 27.11 17.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#767571;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.01,7.44c-.57,0-1.13,.1-1.64,.27L17.07,.29c-.08-.18-.26-.29-.45-.29h-2.53c-.27,0-.5,.22-.5,.5s.22,.5,.5,.5h2.21l1.5,3.38-4.93,7.25-1.88-6.2h.65c.27,0,.5-.22,.5-.5s-.22-.5-.5-.5h-2.55c-.27,0-.5,.22-.5,.5s.22,.5,.5,.5h.86l.34,1.14-2.02,2.02c-.88-.71-1.99-1.13-3.2-1.13C2.29,7.44,0,9.72,0,12.53s2.29,5.09,5.09,5.09c2.55,0,4.67-1.89,5.04-4.34l2.53-.03s.06,0,.1-.01c.14-.02,.27-.09,.35-.21l5.16-7.6,1.2,2.69c-1.52,.88-2.55,2.53-2.55,4.41,0,2.81,2.29,5.09,5.09,5.09s5.09-2.29,5.09-5.09-2.29-5.09-5.09-5.09ZM5.09,16.64c-2.26,0-4.1-1.84-4.1-4.1s1.84-4.1,4.1-4.1,4.1,1.84,4.1,4.1-1.84,4.1-4.1,4.1Zm5.09-4.34c-.05-1.15-.49-2.2-1.18-3.03l1.64-1.64,1.41,4.65-1.86,.02Zm11.83,4.34c-2.26,0-4.1-1.84-4.1-4.1s1.84-4.1,4.1-4.1,4.1,1.84,4.1,4.1-1.84,4.1-4.1,4.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicicle);
export default __webpack_public_path__ + "static/media/Bicicle.9c321c682c8bd4a65c0dfcbba15f5197.svg";
export { ForwardRef as ReactComponent };